import service from "../util/http";
// 正审-索赔单列表
export const climantList = data => {
    return service({
      url: "/manage/kdClaimMange/list",
      method: "post",
      data
    });
};
// 正审索赔单
export const auditClaimant = data => {
    return service({
      url: "/manage/kdClaimMange/formalReview",
      method: "post",
      data
    });
  };
// 审核记录 
export const auditHistoryList = data => {
  return service({
    url: "/manage/kdClaim/auditHistoryList",
    method: "post",
    data
  });
};
// // 历史记录
// export const getHistoryList = data => {
//   return service({
//     url:"/manage/kdClaim/claimHistoryList",
//     method: "post",
//     data
//   });
// };
// 加签
export const countersignClaimant = data => {
  return service({
    url: "/manage/kdClaimMange/countersign",
    method: "post",
    data
  });
};
// 撤回 
export const formalAuditRejectRevocationApi = id => {
  return service({
    url: `/manage/kdClaimMange/revocation/${id}`,
    method: "post"
  });
};
// 正审导出 
export const trialClimantExport = data => {
  return service({
    url: "/manage/kdClaimMange/trialExport",
    method: "post",
    responseType: "blob",
    data
  });
};
// 历史维修记录查看 
export const getHistoryList = data => {
  return service({
    url: "/manage/kdClaimMange/historyRepairLook",
    method: "post",
    data
  });
};
// 获取预设数据
export const getPreset = data => {
  return service({
    url: "/manage/kdClaimMange/getPreset",
    method: "post",
    data
  });
};